<nav class="side-nav" [class.side-nav--expanded]="expanded">

  <!-- ── Brand: Silverpush wordmark (mark-only when collapsed) ── -->
  <div class="side-nav__head">
    <span class="side-nav__logo" role="img" aria-label="Silverpush">
      <!-- Logos are embedded as base64 data-URIs in the SCSS (see background-image)
           because the acmqa server does not serve the static assets/ directory. -->
      <!-- collapsed: mark only -->
      <span class="side-nav__logo-mark"></span>
      <!-- expanded: full wordmark -->
      <span class="side-nav__logo-full"></span>
    </span>
  </div>

  <!-- Collapse / expand toggle — circular button on the rail edge -->
  <button
    type="button"
    class="side-nav__toggle"
    [attr.aria-label]="expanded ? 'Collapse navigation' : 'Expand navigation'"
    [attr.aria-expanded]="expanded"
    (click)="toggle()">
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.6"
            stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <!-- ── Product switcher ── -->
  <ul class="side-nav__list">
    <li *ngFor="let product of products">
      <button
        type="button"
        class="side-nav__item"
        [class.side-nav__item--active]="product.active"
        [attr.aria-current]="product.active ? 'page' : null"
        [title]="product.label"
        (click)="selectProduct(product)">

        <span class="side-nav__icon" [ngSwitch]="product.icon" aria-hidden="true">

          <!-- Go-Live: broadcast / live signal -->
          <svg *ngSwitchCase="'go-live'" width="22" height="22" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="2.4" fill="currentColor"/>
            <path d="M7.5 7.5a6.4 6.4 0 000 9M16.5 7.5a6.4 6.4 0 010 9"
                  stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>
            <path d="M4.8 4.8a10 10 0 000 14.4M19.2 4.8a10 10 0 010 14.4"
                  stroke="currentColor" stroke-width="1.6" stroke-linecap="round" opacity="0.55"/>
          </svg>

          <!-- Planning Suite: layered / stacked sheets -->
          <svg *ngSwitchCase="'planning-suite'" width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M12 3l8.5 4.75L12 12.5 3.5 7.75 12 3z" fill="currentColor"/>
            <path d="M3.5 12l8.5 4.75L20.5 12" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.85"/>
            <path d="M3.5 16.25L12 21l8.5-4.75" stroke="currentColor" stroke-width="1.6"
                  stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.55"/>
          </svg>

        </span>

        <span class="side-nav__label">{{ product.label }}</span>
      </button>
    </li>
  </ul>

</nav>
